/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Container, Grid } from '@material-ui/core';
import ReactMarkdown from 'react-markdown';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';

const styles = (theme) => {
    const { breakpoints: { maxWidth = {} } } = theme;
    return {
        root: {
            maxWidth: '1270px',
            [theme.breakpoints.down(maxWidth?.big_screen_down)]: {
                maxWidth: '960px',
            },
            [theme.breakpoints.down(maxWidth?.small_medium_down)]: {
                maxWidth: '720px',
            },
            [theme.breakpoints.down(maxWidth?.small_screen_down)]: {
                maxWidth: '540px',
                paddingRight: '15px',
                paddingLeft: '15px',
            },
            '& #shipping-info': {
                overflowX: 'hidden',
                width: '100%',
                '& p': {
                    lineHeight: '1.5em',
                },
                '& li': {
                    '& p': {
                        margin: '0',
                    },
                },
                '& #main-heading': {
                    '&.mb-3': {
                        marginBottom: '1rem!important',
                    },
                    '&.pt-4': {
                        paddingTop: '1.5rem!important',
                    },
                    '& h1': {
                        display: 'flex',
                        alignItems: 'baseline',
                        fontFamily: 'BebasNeue',
                        fontSize: '2.8125rem',
                        color: '#000',
                        lineHeight: '3.75rem',
                        textTransform: 'uppercase',
                        fontWeight: 500,
                        margin: 0,
                        '& .info-header-img': {
                            position: 'relative',
                            marginLeft: '20px',
                            '& img': {
                                '&:first-child': {
                                    width: '22px !important',
                                    left: '-15px',
                                    position: 'absolute',
                                    top: '7px',
                                },
                                '&:last-child': {
                                    width: '42px',
                                },
                            },
                        },
                    },
                    '& .sub-title': {
                        '& p': {
                            font: 'bolder 16px/20px Hind, sans-serif',
                            color: '#000',
                            fontWeight: 300,
                            minHeight: '79px',
                            marginBottom: '0.5rem',
                            lineHeight: '1.5em',
                        },
                    },
                },
                '& #shipping-price-list': {
                    '& .row': {
                        marginTop: '3rem',
                    },
                    '& .tableHolder': {
                        padding: '0 15px',
                        width: '100%',
                        position: 'relative',
                    },
                    '& .list-table': {
                        tableLayout: 'fixed',
                        width: '100%',
                        borderCollapse: 'collapse',
                        '& .info-titles': {
                            backgroundColor: '#b9e529',
                            font: '700 16px/20px Hind, sans-serif',
                            [theme.breakpoints.down(maxWidth?.small_medium_down)]: {
                                fontSize: '0.813rem !important',
                            },
                            [theme.breakpoints.down(maxWidth?.xs_screen)]: {
                                fontSize: '0.688rem !important',
                            },
                        },
                        '& tr': {
                            textAlign: 'center',
                            overflowWrap: 'break-word',
                        },
                        '& td, th': {
                            minHeight: '39px',
                            lineHeight: '2.43em',
                        },
                        [theme.breakpoints.down(maxWidth?.small_medium_down)]: {
                            fontSize: '0.688rem !important',
                        },
                        [theme.breakpoints.down(maxWidth?.xs_screen)]: {
                            fontSize: '0.625rem !important',
                        },
                    },
                    '& .list-points': {
                        width: '500px',
                        padding: '0 15px',
                        '& .icon': {
                            width: '25px',
                            height: '25px',
                            fill: '#b9e529',
                            marginRight: '1rem',
                        },
                        '& .list-text': {
                            verticalAlign: 'top',
                            font: 'bolder 16px/20px Hind, sans-serif',
                            paddingLeft: '0px',
                            lineHeight: '1.25em',
                        },
                        '& .li': {
                            lineHeight: '1.25em',
                            display: 'flex',
                            padding: '10px 0px',
                            '& div': {
                                background: 'green',
                                borderRadius: '100%',
                                width: '25px',
                                height: '25px',
                                '& i': {
                                    transform: 'translate(2px, -4px)',
                                    fontSize: '24px',
                                    lineHeight: '1em',
                                },
                            },
                        },
                        '& .li:first-child': {
                            paddingTop: '60px',
                            [theme.breakpoints.down(maxWidth?.small_screen_down)]: {
                                paddingTop: 0,
                            },
                        },
                    },
                    '& .box-image': {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    },
                    '& img': {
                        height: '300px',
                    },
                    [theme.breakpoints.down(maxWidth?.medium_screen_down)]: {
                        '& .list-points': {
                            paddingTop: '0px !important',
                            width: 'auto',
                            span: {
                                width: '25px',
                                height: '25px',
                                background: 'green',
                                display: 'inline-block',
                                marginRight: '10px',
                                borderRadius: '100%',
                            },
                        },
                        '& img': {
                            width: 'auto',
                            height: 'auto',
                            maxWidth: '100%',
                        },
                    },
                    '& .h-seperator': {
                        backgroundImage: 'linear-gradient(90deg, #000 30%, hsla(0,0%,100%,0) 0)',
                        backgroundPosition: 'bottom',
                        backgroundSize: '5px 5px',
                        backgroundRepeat: 'repeat-x',
                        marginTop: '1rem',
                        marginBottom: '1rem',
                        border: 0,
                        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
                    },
                    '& a': {
                        fontFamily: '"Arial", sans-serif',
                        color: '#65388b',
                        textDecoration: 'none',
                        fontWeight: 700,
                        letterSpacing: '0.5px',
                    },
                    '& .subHeader': {
                        textDecoration: 'underline',
                        marginTop: '3rem',
                        textAlign: 'center',
                    },
                },
                '& #last-section': {
                    paddingBottom: '100px',
                    '& .row': {
                        width: '100%',
                        margin: '0px auto',
                    },
                    '& .imgHolder': {
                        marginTop: '1rem',
                        paddingLeft: '3rem',
                        paddingRight: '15px',
                        [theme.breakpoints.down(maxWidth?.medium_screen_down)]: {
                            paddingLeft: '15px',
                        },
                        '& img': {
                            width: '575px',
                            height: '543px',
                            maxWidth: '100%',
                            [theme.breakpoints.down(maxWidth?.medium_screen_down)]: {
                                width: 'auto',
                                height: 'auto',
                            },
                        },
                    },
                    '& .noteHolder': {
                        paddingTop: '3rem',
                        marginTop: '3rem',
                        paddingLeft: '15px',
                        paddingRight: '15px',
                        '& .ps': {
                            width: '115px',
                            height: '69px',
                            background: '#b9e529',
                            transform: 'rotate3d(1, 1, 1, -16deg)',
                            font: '500 29px/27px Marydale',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            marginBottom: '20px',
                            '& p': {
                                paddingLeft: 0,
                            },
                        },
                        '& p': {
                            paddingLeft: '3rem',
                            lineHeight: '1.5em',
                        },
                        [theme.breakpoints.down(maxWidth?.medium_screen_down)]: {
                            paddingTop: 0,
                            '&> div': {
                                paddingTop: '0px !important',
                                paddingLeft: '15px !important',
                                '& .ps + & div': {
                                    paddingLeft: '20px !important',
                                },
                            },
                        },
                    },
                },
            },
        },
    };
};

const SeoShippingInfo = ({ classes, data }) => {
    const {
        hero: { title = '', copy = '' }, article_body = '', article_header = '', overview = '', collapsible_content = {}, customer_reviews_gallery,
    } = data;
    const infoTruck = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt925a36d22b250f02/63b5eb66df80d633dbe5cc3e/info-shiping.png';
    const shippingTruck = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/bltbe8661d1ca91d013/63b5ea8fe013ff1073e29564/truck-shipping.jpg';
    const plantsBox = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt00eaa9a019b20c48/63b5f8127760ab1f00b010b6/plants-com-box.png';
    const deliveryProduct = 'https://images.contentstack.io/v3/assets/blt4454dc0093319d35/blt0394581d1c2e960b/63b768324efa494a5213ee5b/delivery_product.png';
    const list = customer_reviews_gallery?.sub_heading.split('\n');

    const renderList = list.map((row) => (
        <>
            <div className="li"><CheckCircleIcon className="icon" /><span className="list-text"><strong>{row}</strong></span></div>
        </>
    ));

    return (
        <Container className={classes.root}>
            <section id="shipping-info">
                <article id="main-heading" className="mb-3 pt-4">
                    <h1>{title}<span className="info-header-img"><img src={infoTruck} alt="info truck" /><img src={shippingTruck} alt="shipping truck" /></span></h1>
                    <div className="sub-title"><ReactMarkdown source={copy} escapeHtml={false} /></div>
                </article>
                <article id="shipping-price-list">
                    <ReactMarkdown source={article_body} escapeHtml={false} className="tableHolder" />
                    <Grid container direction="row" className="row">
                        <Grid item direction="column" xs={12} sm={6} md={6} lg={6} className="list-points">
                            {renderList}
                        </Grid>
                        <Grid item direction="column" xs={12} sm={6} md={6} lg={6} className="box-image">
                            <img src={plantsBox} alt="delivery product" />
                        </Grid>
                    </Grid>
                    <ReactMarkdown source={article_header} escapeHtml={false} className="subHeader" />
                    <ReactMarkdown source={overview} escapeHtml={false} />
                    <hr className="h-seperator" />
                </article>
                <article id="last-section">
                    <Grid container direction="row">
                        <Grid item direction="column" sm={5} md={5} lg={5} className="imgHolder">
                            <img src={deliveryProduct} alt="delivery product" />
                        </Grid>
                        <Grid item direction="column" sm={7} md={7} lg={7} className="noteHolder">
                            <ReactMarkdown className="ps" source={collapsible_content?.title} escapeHtml={false} />
                            <ReactMarkdown source={collapsible_content?.copy} escapeHtml={false} />
                        </Grid>
                    </Grid>
                </article>
            </section>
        </Container>
    );
};

SeoShippingInfo.propTypes = {
    data: object.isRequired,
    classes: object.isRequired,
};

export default withStyles(styles)(SeoShippingInfo);
